import type { Row, RowData } from "@tanstack/react-table";
import dayjs from "dayjs";

function isWithInAWeek(date: dayjs.Dayjs): boolean {
  const numberOfDays = 7;
  const weekOld = dayjs().subtract(numberOfDays, "days").startOf("day");

  return date.isAfter(weekOld);
}

const formatDate = (value: string): string =>
  value && value !== "-" ? dayjs(value).format("YYYY-MM-DD") : "-";

const formatDateTime = (value: string): string =>
  value && value !== "-" ? dayjs(value).format("YYYY-MM-DD hh:mm A") : "-";

const formatIsoDate = (value: string): string =>
  value ? dayjs(value).format("YYYY-MM-DD hh:mm:ss A") : "-";

const getDatePlusDeltaDays = (date: string, days: number): string =>
  dayjs(date).add(days, "days").format("YYYY-MM-DD hh:mm:ss A");

const getRemainingDays = (value: string): number =>
  dayjs(value).diff(dayjs(), "days");

const filterDate = <TData extends RowData>(
  row: Row<TData>,
  columnId: string,
  filterValue: [number | undefined, number | undefined],
): boolean => {
  const currentDate = dayjs(row.getValue<string>(columnId)).valueOf();
  const isHigher =
    filterValue[0] === undefined ? true : currentDate >= filterValue[0];
  const isLower =
    filterValue[1] === undefined ? true : currentDate <= filterValue[1];

  return isHigher && isLower;
};

export {
  formatDate,
  formatDateTime,
  formatIsoDate,
  getDatePlusDeltaDays,
  getRemainingDays,
  isWithInAWeek,
  filterDate,
};
